import { render, staticRenderFns } from "./WarrantyBillItemV2.vue?vue&type=template&id=232aefba&scoped=true"
import script from "./WarrantyBillItemV2.vue?vue&type=script&lang=js"
export * from "./WarrantyBillItemV2.vue?vue&type=script&lang=js"
import style0 from "./WarrantyBillItemV2.vue?vue&type=style&index=0&id=232aefba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232aefba",
  null
  
)

export default component.exports